import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type BuscarProcurasSemCompatibilidadesResponse = {
  total?: number;
  totalINT?: number;
  totalPOST?: number;
  procuras?: Record<string, any>[];
};

export const buscarProcurasSemCompatibilidadesService = async () => {
  const Token = validateToken();

  if (Token) {
    const URL =
      `${Globais.DOMINIOBACK}/compatibilidades/procuras/sem-compatibilidades`;

    try {
      const response = await axios.get<BuscarProcurasSemCompatibilidadesResponse>(
        URL,
        {
          headers: { Authorization: Token.AuthStr },
        }
      );

      if (response && response.data) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return false;
};
